export default __webpack_public_path__ + "fonts/stacy-logo.svg";